import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModErrorComponent } from '../../modals/mod-error/mod-error.component';
import { AccessService } from '../../service/access.service';

@Component({
  selector: 'app-saa-delegate-confirmation',
  templateUrl: './saa-delegate-confirmation.component.html',
  styleUrls: ['./saa-delegate-confirmation.component.css']
})
export class SaaDelegateConfirmationComponent implements OnInit {

  name  = "XXXXXX"
  email = "XXXXXX"
  constructor( private route: ActivatedRoute,public dialog: MatDialog,private spinner: NgxSpinnerService,private dataApiAccess: AccessService ) {
    if(this.route.snapshot.queryParamMap.get('name')!=null){
      this.name =   this.route.snapshot.queryParamMap.get('name');
    }
    if(this.route.snapshot.queryParamMap.get('email')!=null){
      this.email = this.route.snapshot.queryParamMap.get('email');
    }

  }

  ngOnInit() {
    this.spinner.show("AccessValidation")
    this.dataApiAccess.getValidatePermision().subscribe(
      (data: any)=>{
        this.spinner.hide("AccessValidation");
        if(data) {

        }else{
          sessionStorage.clear();
          window.location.reload();
         }
      },
      ()=>{
        this.spinner.hide("AccessValidation");

        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',

        });
      }
    )
  }

}
